// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"623":"Notifications","665":"SearchHistory","672":"NotificationSettings"}[chunkId] + "-" + {"623":"5c2a42e22f30c8b87c6c","665":"1d22bf04971d795111ba","672":"52d71b92cf13f64aa507"}[chunkId] + ".js";
};